import { Component } from '@angular/core';
import { HeroEmpresarialComponent } from "../../hero-empresarial/hero-empresarial.component";

@Component({
  selector: 'app-hero-terapia-fisica',
  standalone: true,
  imports: [HeroEmpresarialComponent],
  templateUrl: '../../hero-empresarial/hero-empresarial.component.html',
  styleUrl: './hero-terapia-fisica.component.css'
})
export class HeroTerapiaFisicaComponent {
  name="Terapia Física y Traumatología";
  description = "Servicios de salud especializados en el tratamiento de lesiones músculo-esqueléticas y en la rehabilitación física.";
  description2 = "Estos servicios ayudan a prevenir, diagnosticar y tratar lesiones derivadas del trabajo o accidentes laborales.";
  routeLogo = "assets/img/enterprise/menu/terapiaFisicaTraumo.svg";
  routeImage = "assets/img/enterprise/hero/fotoTerapiaFisica.svg"

}
